// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------

import Layout from '@/layout';
var businessRouter = {
  path: '/business',
  component: Layout,
  redirect: '/business/index',
  name: 'business',
  meta: {
    title: '企业管理',
    icon: 'clipboard'
  },
  children: [{
    path: 'clientManage',
    name: 'clientManage',
    component: function component() {
      return import('@/views/business/clientManage');
    },
    meta: {
      title: '客户管理',
      icon: 'clipboard',
      roles: ['admin']
    },
    children: [{
      path: 'coupons',
      name: 'coupons',
      component: function component() {
        return import('@/views/business/clientManage/coupons/index.vue');
      },
      meta: {
        title: '卡券客户'
      }
    }, {
      path: 'conventional',
      name: 'conventional',
      component: function component() {
        return import('@/views/business/clientManage/conventional/index.vue');
      },
      meta: {
        title: '常规客户'
      }
    }, {
      path: 'applet',
      name: 'applet',
      component: function component() {
        return import('@/views/business/clientManage/applet/index.vue');
      },
      meta: {
        title: '小程序客户'
      }
    }, {
      path: 'distributor',
      name: 'distributor',
      component: function component() {
        return import('@/views/business/clientManage/distributor/index.vue');
      },
      meta: {
        title: '小程序客户商品管理',
        hidden: true,
        activeMenu: "/business/clientManage/applet"
      }
    }, {
      path: 'pintuanBusiness',
      name: 'pintuanBusiness',
      component: function component() {
        return import('@/views/business/clientManage/pintuanBusiness/index.vue');
      },
      meta: {
        title: '客户拼团商品管理',
        hidden: true,
        activeMenu: "/business/clientManage/applet"
      }
    }, {
      path: 'dangaoBusiness',
      name: 'dangaoBusiness',
      component: function component() {
        return import('@/views/business/clientManage/dangaoBusiness/index.vue');
      },
      meta: {
        title: '蛋糕商品管理',
        hidden: true,
        activeMenu: "/business/clientManage/applet"
      }
    }, {
      path: 'jingdongGoods',
      name: 'jingdongGoods',
      component: function component() {
        return import('@/views/business/clientManage/jingdongGoods/index.vue');
      },
      meta: {
        title: '小程序客户商品授权 ',
        hidden: true,
        activeMenu: "/business/clientManage/applet"
      }
    }, {
      path: 'customerPointsManagement',
      name: 'customerPointsManagement',
      component: function component() {
        return import('@/views/business/clientManage/customerPointsManagement');
      },
      meta: {
        title: '客户福豆管理',
        icon: ''
      }
    }, {
      path: 'staffManage',
      name: 'staffManage',
      component: function component() {
        return import('@/views/business/clientManage/staffManage/index.vue');
      },
      meta: {
        title: '员工管理',
        icon: ''
      }
    }]
  }, {
    path: 'company',
    name: 'company',
    component: function component() {
      return import('@/views/business/company');
    },
    meta: {
      title: '合作公司',
      icon: ''
    },
    children: [{
      path: 'list',
      name: 'list',
      component: function component() {
        return import('@/views/business/company/list');
      },
      meta: {
        title: '合作公司列表',
        icon: ''
      }
    }, {
      path: 'houseShop',
      name: 'houseShop',
      component: function component() {
        return import('@/views/business/company/houseShop');
      },
      meta: {
        title: '家政门店列表',
        icon: ''
      }
    }]
  }, {
    path: 'supplier',
    name: 'supplier',
    component: function component() {
      return import('@/views/business/supplier');
    },
    meta: {
      title: '供应商管理',
      icon: ''
    },
    children: [{
      path: 'coupons',
      name: 'coupons',
      component: function component() {
        return import('@/views/business/supplier/coupons');
      },
      meta: {
        title: '卡券供应商',
        icon: ''
      }
    }, {
      path: 'entity',
      name: 'entity',
      component: function component() {
        return import('@/views/business/supplier/entity');
      },
      meta: {
        title: '实物供应商',
        icon: ''
      }
    }, {
      path: 'oneCard',
      name: 'oneCardSupplier',
      component: function component() {
        return import('@/views/business/supplier/coupons');
      },
      props: {
        supplierType: 6,
        simpleActions: true
      },
      meta: {
        title: '一卡通供应商',
        icon: ''
      }
    }, {
      path: 'domestic',
      name: 'domestic',
      component: function component() {
        return import('@/views/business/supplier/domestic');
      },
      meta: {
        title: '家政供应商',
        icon: ''
      }
    }, {
      path: 'offset',
      name: 'offset',
      component: function component() {
        return import('@/views/business/supplier/offset');
      },
      meta: {
        title: '核销供应商',
        icon: ''
      }
    }]
  }, {
    path: 'integralManage',
    name: 'integralManage',
    component: function component() {
      return import('@/views/business/integralManage');
    },
    meta: {
      title: '福豆管理',
      icon: ''
    },
    children: [{
      path: 'record',
      name: 'record',
      component: function component() {
        return import('@/views/business/integralManage/record');
      },
      meta: {
        title: '客户操作记录',
        icon: ''
      }
    }, {
      path: 'staff',
      name: 'staff',
      component: function component() {
        return import('@/views/business/integralManage/staff');
      },
      meta: {
        title: '员工福豆明细',
        icon: ''
      }
    }, {
      path: 'convertFudou',
      name: 'convertFudou',
      component: function component() {
        return import('@/views/business/integralManage/convertFudou');
      },
      meta: {
        title: '福豆转移',
        icon: ''
      }
    }]
  }, {
    path: 'welfareCard',
    name: 'welfareCard',
    component: function component() {
      return import('@/views/business/welfareCard');
    },
    meta: {
      title: '福利卡管理',
      icon: 'gift'
    },
    children: [{
      path: 'package',
      name: 'welfareCardPackage',
      component: function component() {
        return import('@/views/business/welfareCard/package');
      },
      meta: {
        title: '福卡包管理',
        icon: ''
      }
    }]
  }]
};
export default businessRouter;